import { timeFormat, } from '../store/helpers'

export default (value) => {
  return timeFormat(value)
}



// WEBPACK FOOTER //
// ./src/filters/dateFormat.js